<script lang="ts">
</script>

<p>
	I exist only to ensure that the typing is right in cases where we have a Record&lt;unknown,
	Component&gt; where Component is of type
	<a
		href="https://svelte.dev/docs/svelte/svelte#Component"
		target="_blank"
		rel="noopener noreferrer">Svelte Component</a
	>.
	<br />
	So if you see me rendered, that's probably a mistake, and you probably need a special conditional handling
	for whichever key has this component in the Record. 😃
</p>
